<template>
	<div
		class="bg-darkestGreen relative max-h-[600px] w-full max-w-(--breakpoint-2xl) 2xl:mx-auto"
	>
		<KeepAlive>
			<video
				autoplay
				muted
				loop
				class="pointer-events-none max-h-[580px] min-h-[320px] w-full object-cover brightness-[0.60]"
			>
				<source
					src="https://www.propellerfestival.de/images/header_mov.mp4"
					type="video/mp4"
				/>
			</video>
		</KeepAlive>
		<div class="wave">
			<svg
				data-name="Layer 1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1200 120"
				preserveAspectRatio="none"
			>
				<path
					d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
					class="fill-white dark:fill-neutral-950"
				></path>
			</svg>
		</div>
		<div class="absolute top-0 right-0 left-0 mt-12 sm:mt-20 md:mt-28">
			<slot />
		</div>
	</div>
</template>

<script lang="ts" setup></script>

<style>
.wave {
	position: absolute;
	bottom: -2px;
	left: 0;
	width: 100%;
	overflow: hidden;
	line-height: 0;
}

.wave svg {
	position: relative;
	display: block;
	width: calc(115% + 1.3px);
	height: 181px;
}
</style>
